module.exports = __webpack_public_path__ + "static/img1-70e77e0638e6f73a793a918a48985268.jpg";